import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useSeo from "../hooks/useSeo";
import { COLLECTIONS, getProductsByCollection } from "../data/products";

const Collections = () => {
  useSeo({
    title: "Collections",
    description: "Explore 9'One Store collections — Oversized, Essentials, Graphics and Minimal.",
    path: "/collections",
  });

  return (
    <div className="animate-fade-in">
      <div className="border-b border-ink">
        <div className="container-9one py-12">
          <p className="label-mono text-ink/50">Curated Edits</p>
          <h1 className="mt-2 font-display text-5xl uppercase tracking-tight sm:text-7xl">Collections</h1>
        </div>
      </div>

      <div className="container-9one py-12">
        <div className="grid gap-px bg-ink sm:grid-cols-2">
          {COLLECTIONS.map((c, i) => (
            <Link
              key={c.slug}
              to={`/shop?collection=${c.slug}`}
              className="group relative aspect-[4/3] overflow-hidden bg-cream"
              data-testid={`collection-card-${c.slug}`}
            >
              <img
                src={c.image}
                alt={c.name}
                loading="lazy"
                className="h-full w-full object-cover grayscale transition-all duration-500 group-hover:grayscale-0 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/75 via-ink/10 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6 text-paper sm:p-8">
                <p className="label-mono text-brand">0{i + 1} — {getProductsByCollection(c.slug).length} items</p>
                <h2 className="mt-2 font-display text-4xl uppercase tracking-tight sm:text-5xl">{c.name}</h2>
                <p className="mt-1 text-sm text-paper/70">{c.tagline}</p>
                <span className="mt-4 inline-flex items-center gap-1 label-mono">
                  Shop {c.name} <ArrowUpRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Collections;
